import { createPortal } from 'react-dom';
import { useTheme } from 'styled-components';
import { getAvatarGradient, getInitials } from 'utils';
import useAnchored, { AnchorPoint } from 'hooks/useAnchored';
import { MentionUser } from '../mentions';
import * as S from './styles';

interface MentionCardProps {
	mentionUser: MentionUser;
	anchor: AnchorPoint | null;
}

// Identity popup for a mention — shown while the caret sits inside one in the
// composer, or on hover over one in a posted comment. Purely informational:
// no pointer events, so it can never steal focus or clicks.
const MentionCard = ({ mentionUser, anchor }: MentionCardProps) => {
	const theme = useTheme();
	const { ref, style } = useAnchored(anchor, mentionUser.id);

	return createPortal(
		<S.Base ref={ref} style={style}>
			<S.Avatar style={{ background: getAvatarGradient(mentionUser.displayName, theme) }}>
				{getInitials(mentionUser.displayName)}
			</S.Avatar>
			<S.Info>
				<S.Name>
					{mentionUser.displayName}
					{mentionUser.isSelf && <S.You>you</S.You>}
				</S.Name>
				<S.Email>{mentionUser.email}</S.Email>
			</S.Info>
		</S.Base>,
		document.body
	);
};

export default MentionCard;
